var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { loadScript } from '../../utils';
import { DEFAULT_WIX_SDK_SRC } from '../../constants';
import { WixSDKContext, defaultWixSDKContext, } from './SDKContext';
var WixSDKProvider = /** @class */ (function (_super) {
    __extends(WixSDKProvider, _super);
    function WixSDKProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: defaultWixSDKContext,
        };
        var Wix = null;
        if (props.Wix) {
            Wix = props.Wix;
        }
        _this.state = {
            value: { Wix: Wix },
        };
        return _this;
    }
    WixSDKProvider.prototype.componentDidMount = function () {
        var _this = this;
        // This Provider can be used in tests or any other environment, where window.Wix was already loaded.
        // To prevent re-fetching it or pass mocked Wix SDK we allow to pass it via props.
        if (this.props.Wix || this.props.disabled) {
            return;
        }
        this.loadSDK(DEFAULT_WIX_SDK_SRC).then(function () {
            var Wix = window.Wix;
            _this.setState({ value: { Wix: Wix } });
        });
    };
    WixSDKProvider.prototype.loadSDK = function (src) {
        return loadScript(src);
    };
    WixSDKProvider.prototype.render = function () {
        return (React.createElement(WixSDKContext.Provider, { value: this.state.value }, this.props.children));
    };
    return WixSDKProvider;
}(React.Component));
export { WixSDKProvider };
//# sourceMappingURL=WixSDKProvider.js.map